import { isSameDay } from 'date-fns';

export const getHoursResetValue = (dateFrom, dateTo) => {
  if (isSameDay(dateFrom, dateTo)) {
    return 1;
  } else {
    return null;
  }
};
